//TODO - questo metodo a tendere dovrà essere tolto per essere spostato dentro la action.

class LandingUrlBuilder {
    constructor() {
    }

    updateUrl($form, $input) {
        console.log("form");
        console.log($form);
        console.log("input");
        console.log($input);
        if (!!$input && $input.length > 0) {
            let lingua = 'it';
            let programme = 'generic';
            let campus = 'generic';
            let area = 'generic';
            let ringraziamento = '';

            if (KD_COMMON_CONSTANTS.LOCALE == 'en_GB') {
                ringraziamento = 'thank-you';
                lingua = 'en';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'zh_CN') {
                ringraziamento = 'thank-you-zh';
                lingua = 'zh';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'fr_FR') {
                ringraziamento = 'merci';
                lingua = 'fr';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'it_IT') {
                ringraziamento = 'grazie';
                lingua = 'it';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'es_ES') {
                ringraziamento = 'gracias';
                lingua = 'es';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'de_DE') {
                ringraziamento = 'danke';
                lingua = 'de';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'pt_BR') {
                ringraziamento = 'obrigado';
                lingua = 'pt-br';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'ar_AE') {
                ringraziamento = 'thank-you';
                lingua = 'ar';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'ko_KP') {
                ringraziamento = 'thank-you';
                lingua = 'ko';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'ja_JP') {
                ringraziamento = 'thank-you';
                lingua = 'ja';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'vi_VN') {
                ringraziamento = 'thank-you';
                lingua = 'vi';
            } else if (KD_COMMON_CONSTANTS.LOCALE == 'ru_RU') {
                ringraziamento = 'thank-you';
                lingua = 'ru';
            }
            if (!!$form) {
                if ($form.find('[name="programme_code"]').length > 0 && !!$form.find('[name="business_unit_code"]').val()) {
                    programme = $form.find('[name="programme_code"]').val();
                    if ($form.find('[name="programme_code"]').is("[data-custom-ty-programme]")) {
                        programme = $form.find('[name="programme_code"]').data('customTyProgramme');
                    }
                }
                if ($form.find('[name="business_unit_code"]').length > 0 && !!$form.find('[name="programme_code"]').val()) {
                    campus = $form.find('[name="business_unit_code"]').val().replace(' ', '-');
                }
                if ($form.find('[name="study_area_code"]').length > 0 && !!$form.find('[name="study_area_code"]').val()) {
                    area = $form.find('[name="study_area_code"]').val();
                }
            }

            let protocol = 'https';
            if (KD_COMMON_CONSTANTS.LOCALE == 'zh_CN') {
                protocol = 'http';
            }
            // /en/LandingMinimal/foundation-year/milano-fashion/fashion-design/thank-you
            let retUrl = `${protocol}://${document.location.hostname}/landing/${lingua}/landingminimal/${programme}/${campus}/${area}/${ringraziamento}`;
            retUrl = retUrl.toLocaleLowerCase();
            $input.val(retUrl.split(" ").join("-").replace(/[^a-zA-Z0-9_\-/:.]/g, ""));
        }
    }
}

export default new LandingUrlBuilder();
